import React from 'react';
import classnames from 'classnames';

const UserAvatar: React.FC<{
  avatar: string;
  text: string;
  initials: string;
  onlyAvatar?: boolean;
  multiple?: boolean;
  editable?: boolean;
  onRemove?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}> = ({ avatar, initials, text, onlyAvatar, multiple, onRemove, editable }) => {
  return (
    <div
      className={classnames('tw-flex tw-items-center tw-gap-1 tw-shrink-0', {
        'tw-border tw-border-primary-border tw-border-solid tw-pr-2 tw-pl-1 tw-py-[2px] tw-rounded-xl tw-bg-primary-background tw-text-primary':
          multiple && !onlyAvatar,
      })}
    >
      <aha-avatar
        class='!tw-box-border !tw-m-0 !tw-transform-none'
        size={onlyAvatar ? 18 : 16}
        src={avatar || null}
        name={text}
        label={initials}
      />
      {!onlyAvatar && (
        <span className='tw-leading-none tw-text-sm'>{text}</span>
      )}
      {editable && multiple && !onlyAvatar && (
        <a
          onClick={onRemove}
          className='tw-leading-none tw-flex tw-items-center tw-justify-center hover:tw-no-underline'
        >
          <i
            className='fa-solid fa-xmark tw-text-xs tw-cursor-pointer tw-text-[--theme-tertiary-text] tw-ml-1'
            aria-label={`Remove ${text}`}
          />
        </a>
      )}
    </div>
  );
};

export default UserAvatar;
